export function extractAddressFromLocation(location) {
  /**
   * Location Object:
   * {
   *      admin_area: "KA"
   *      altitude: "0.0"
   *      country: "India"
   *      country_code: "IN"
   *      course: "-1.0"
   *      latitude: "12.94204284816332"
   *      locality: "Bengaluru"
   *      longitude: "77.69737725769862"
   *      postal_code: "560103"
   *      speed: "-1.0"
   *      sub_admin_area: "Bengaluru Urban"
   *      sub_locality: "Kadubisanahalli"
   *      sub_thoroughfare: null
   *      thoroughfare: "Outer Ring Road"
   *      time_zone: "Asia/Kolkata (fixed (equal to current))"
   * }
   */
  // console.log('extractAddressFromLocation', location);
  if (!location) return null;

  let address = [];
  if (!!location.thoroughfare) address.push(location.thoroughfare);
  if (!!location.sub_locality) address.push(location.sub_locality);
  if (!!location.locality) address.push(location.locality);
  if (!!location.admin_area) address.push(location.admin_area);

  return address.join(", ");
}

export function angleFromCoordinates(lat1, long1, lat2, long2) {
  // const dLon = long2 - long1;

  // const y = Math.sin(dLon) * Math.cos(lat2);
  // const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);

  // let brng = Math.atan2(y, x);

  // const pi = Math.PI;
  // brng = brng * (180 / pi);
  // brng = (brng + 360) % 360;
  // brng = 360 - brng; // count degrees counter-clockwise - remove to make clockwise

  // return brng;
  if(isNaN(lat1) || isNaN(long1) || isNaN(lat2) || isNaN(long2)) return 0
  let angleCounterClockWithX = Math.atan2(lat2 - lat1, long2 - long1) * (180 / Math.PI);
  let angleClockWithX = -(angleCounterClockWithX)
  let angleWithVertical = angleClockWithX + 90
  return angleWithVertical
}

export function isLocationsEqual(location1, location2){
  return location1[1] === location2[1] && location1[0] === location2[0]
}

export function calcDistance(lat1, lat2, lon1, lon2){
  // degrees to radians.
  lon1 =  lon1 * Math.PI / 180;
  lon2 = lon2 * Math.PI / 180;
  lat1 = lat1 * Math.PI / 180;
  lat2 = lat2 * Math.PI / 180;
  // Haversine formula
  let dlon = lon2 - lon1;
  let dlat = lat2 - lat1;
  let a = Math.pow(Math.sin(dlat / 2), 2)
  + Math.cos(lat1) * Math.cos(lat2)
  * Math.pow(Math.sin(dlon / 2),2);
  let c = 2 * Math.asin(Math.sqrt(a));
  // Radius of earth in kilometers. Use 3956
  // for miles
  let r = 6371;
  // calculate the result
  return(c * r) * 1000; //result in meters
}

export function getAngleFromCoordinatesHistoryFunction(){
  // calculates the angle between the current location and
  // latest location that is further than 200m(minTravelDistance) away
  let minTravelDistance = 100 //in meters
  let lastConsideredLocation = null
  let previousAngle = 0
  let uniqueLoadIdentifier = null
  function getAngle(lat1, lon1, lat2, lon2, loadIdentifier){
    if(uniqueLoadIdentifier !== loadIdentifier){
      // reset if the load is different, (the page is loaded with new dispatch)
      lastConsideredLocation = null
      previousAngle = 0
      uniqueLoadIdentifier = loadIdentifier
    }
    if(!(lat1 && lat2 && lon1 && lon2))return 0
    if(!lastConsideredLocation) lastConsideredLocation = [lat1, lon1]
    let distance = calcDistance(lat1, lat2, lon1, lon2)
    if(distance > minTravelDistance){
      let angle = angleFromCoordinates(lat1, lon1, lat2, lon2)
      lastConsideredLocation = [lat1, lon1]
      previousAngle = angle
      // console.log("ANGLE1", angle)
      return angle
    }else{
      distance = calcDistance(lastConsideredLocation[0], lat2, lastConsideredLocation[1], lon2)
      if(distance > minTravelDistance){
        let angle = angleFromCoordinates(lastConsideredLocation[0], lastConsideredLocation[1], lat2, lon2)
        lastConsideredLocation = [lat1, lon1]
        previousAngle = angle
        // console.log("ANGLE2", angle)
        return angle
      }else{
        // console.log("ANGLE3", previousAngle)
        return previousAngle
      }
    }
  }
  return getAngle;
}